/*
 * @Date: 2022-08-30 15:43:44
 * @LastEditors: kinfai
 * @Description: 消息类型集合
 * @LastEditTime: 2022-08-30 15:53:18
 * @FilePath: \my-app\src\pages\ChatConversation\components\MsgType\index.jsx
 */
import useTaskMsg from "../../../../hooks/taskMessage";
import RobetTip from "../../../RobetTip";


const FormMsg = props => {
    const {value} = props

    const Slot = () => {
        if (props.Slot) {
            const Content = props.Slot
            return <Content></Content>
        }
        return value
    }

    return <div className='g-chat-form-msg'>
        <Slot/>
    </div>
}

const MeMsg = props => {
    const {value} = props

    return <div
        className='g-chat-me-msg'
        style={{
            maxWidth: "80%",
            display: 'inline-block'
        }}>
        {value}
    </div>
}

const RobotMsg = props => {
    const {emitAnswer} = useTaskMsg()

    const text = props.text || []
    const addTextMsg = props.addTextMsg

    const questions = []
    if (typeof [] === 'object' && text instanceof Array) {
        text.forEach(item => {
            questions.push({
                ...item,
                value: item.title
            })
        })
    }

    const questionConfig = {
        greetings: "Hello, Can I help you?",
        questions
    }

    // 提问 = 游客发消息 + 机器人自动回复
    const askQuestionsHandle = async (questionId, questionText) => {
        addTextMsg && await addTextMsg(questionText)
        await emitAnswer(questionId)
    }

    const Slot = () => <div>
        <p className="s-question-title">{questionConfig.greetings}</p>
        {
            questionConfig.questions.map(
                (q, index) =>
                    <p
                        key={index}
                        className='s-questions-row'
                        onClick={() => askQuestionsHandle(q.question_id, q.value)}>{q.value}</p>)
        }
    </div>

    return <FormMsg Slot={Slot}></FormMsg>
}

const TransferMsg = props => {
    const {name} = props

    return <p style={{textAlign: 'center'}}>
        <span className="s-transfer-name">{name}</span>
        <span className="s-transfer-text">Join the chat</span>
    </p>
}

const LevelMsg = props => {
    return <div style={{
        position: 'relative',
        marginTop: '50px'
    }}>
        <RobetTip tip={props.tip}/>
    </div>
}

const LevelMsgInfo = props => {
    const value = props.value || {};
    let rowConfigMap = [
        {
            key: "name",
            label: "Name",
            value: ""
        },
        {
            key: "email",
            label: "Email",
            value: ""
        },
        {
            key: "phone",
            label: "Phone",
            value: ""
        },
        {
            key: "content",
            label: "Describe",
            value: ""
        }
    ]

    const showList = rowConfigMap
        .filter(item => value[item.key])
        .map(item => {
            item.value = value[item.key]
            return item
        })

    return <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    }}>
        <p style={{
            marginBottom: "14px",
            color: "rgba(164, 173, 179, 1)",
            fontSize: "12px",
            textAlign: "center",
            fontFamily: "SourceHanSansSC-regular",
        }}> You leave a message</p>
        {/*07/01 10:11*/}
        <div style={{
            borderRadius: "20px 20px 20px 20px",
            backgroundColor: "rgba(255, 255, 255, 1)",
            padding: "8px 20px",
            boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.1)",
            width: "85%",
            display: "inline-block",
        }}>
            {
                showList.map((row, index) => {
                    return <p
                        key={index}
                        style={{
                            fontSize: "14px",
                            fontFamily: "Roboto"
                        }}>
                        <span>{row.label}：</span>
                        <span>{row.value}</span>
                    </p>
                })
            }
        </div>
    </div>
}

export default {
    FormMsg,
    RobotMsg,
    MeMsg,
    TransferMsg,
    LevelMsg,
    LevelMsgInfo
}
